import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CASINO_FULL_URL: InjectionToken<string> = new InjectionToken<string>('casinoFullUrl');

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LIVE_CASINO_FULL_URL: InjectionToken<string> = new InjectionToken<string>('liveCasinoFullUrl');
